import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';

import style from './style.module.scss';

const BUTTON_TEXT = 'Done';
export function DoneButton(props) {
  const onButtonClick = () => {
    props.toggleModal(!props.isModalOpen);
  };
  return (
    <div className={style.doneButton}>
      <Button onClick={onButtonClick}>{BUTTON_TEXT}</Button>
    </div>
  );
}

DoneButton.propTypes = {
  /**
   * Modal window to open when clicking on the HeatBlock
   */
  isModalOpen: PropTypes.bool.isRequired,
  /**
   * Function to triger the modalwindow,to change the state 'isModalOpen'
   */
  toggleModal: PropTypes.func,
};
